import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { EventEmitter } from '@angular/core';
import { HeaderUtilsService } from '../header-utils.service';
import { ProductService } from 'src/app/services/product/product.service';
import { Events,ModalController,NavController } from '@ionic/angular';
import { SelectLanguagePage } from 'src/app/pages/select-language/select-language.page';
import { encodeURL } from 'src/app/services/parseURL';
import { Storage } from "@ionic/storage";
import { SharedService } from "src/app/services/shared/shared.service";
import { VendorService } from "src/app/services/vendor/vendor.service";
import { ConfigService } from 'src/app/services/config/config.service';


@Component({
    selector: 'app-header-three',
    templateUrl: './header-three.component.html',
    styleUrls: ['./header-three.component.scss'],
})
export class HeaderThreeComponent implements OnInit {
    @Input() headerData: any;
    @Input() data: any;
    @Input() region: any;
    @Output() openRegionModalEvent = new EventEmitter();
    @Input() stickyHeader: boolean;
    @Output() getStickyHeight = new EventEmitter();

    @ViewChild('navMenu', {
        static: false
    }) navMenu: ElementRef;
    @ViewChild('catDropdown', { static: false }) catDropdown: ElementRef;
    @ViewChild('navDrop', { static: false }) navDrop: ElementRef;
    @ViewChild('dropIcon', { static: false }) dropIcon: ElementRef;
    @ViewChild('langDropdown', { static: false }) langDropdown: ElementRef;


    loginStatus = false;
    isPriceReq: boolean;
    showPrices: boolean;
    page: number = 0;
    stickyHeight = 150;
    algoliaProducts: any[] = [];
    isIOS;
    role: any;
    userId: string = '';
    priceForRetail = false;
    currencyCode: any;
    RFQFeature = false;
    noMoreProducts: boolean = false;
    displaySearchResult;

    categoriesMenu;
    searchText = "";
    isOpenSearch;
    typingTimer;
    showSearchLoader: boolean = false;
    searchsubscribed: boolean = false;
    showNoProducts = false;
    cartProducts = [];
    doneTypingInterval = 1000;

    constructor(private router: Router,
        private events: Events,
        public userService: UserService,
        private headerUtilsService: HeaderUtilsService,
        private productService:ProductService,
        private modalController: ModalController,
        private utilsService: UtilsService,
        private storage:Storage,
        private sharedService: SharedService,
        private navCtrl: NavController,
        private vendorService: VendorService,
		private configService: ConfigService
        ) { }

    dropMenu() {
        const navMenu = this.navMenu.nativeElement.parentNode.classList;
        console.log(navMenu.toggle('dBlock'));
    }
    dropClick() {
        const catDropdown = this.catDropdown.nativeElement.classList;
        const dropIcon = this.dropIcon.nativeElement.classList;
        catDropdown.toggle('dBlock');
        dropIcon.toggle('dropdownIcon');
    }

    dropNav() {
        this.navDrop.nativeElement.classList.toggle('dBlock');
    }

    openRegionModal(type) {
        this.openRegionModalEvent.emit(type);
    }

    async ngOnInit() {
        if (this.data) {
            this.role = this.data.role;
            this.priceForRetail = this.data.priceForRetail;
			// for the case when currency code is not initialized yet in page-header component
			if (this.data.currencyCode === undefined) {
				this.currencyCode = this.configService.environment.currencyCode;
			} else {
           		this.currencyCode = this.data.currencyCode;
			}
            this.currencyCode = this.data.currencyCode;
            this.RFQFeature = this.data.loginStatus;
        }
        this.initializeSubscriptions();

        this.loginStatus = this.headerUtilsService.getLoginStatus();
        this.categoriesMenu = await this.productService.getCategoriesWithSubcategoriesForMenu();


    }
    async initializeSubscriptions() {
        this.events.subscribe('auth:logoutSuccess', () => {
            this.loginStatus = false;
        })
    }

    ngOnDestroy() {
        this.removeSubscriptions();
    }
    removeSubscriptions() {
        this.events.subscribe('auth:logoutSuccess');
    }
    logout() {
        this.events.publish('auth:logout');
    }
    async openLoginModal() {
        this.utilsService.openLoginModal();
    }
    openSearchPage() {
        this.headerUtilsService.openSearchPage();
    }
    urlName(pname: string) {
        return encodeURL(pname);
    }
    async openSelectLanguageModal() {
        const modal = await this.modalController.create({
            component: SelectLanguagePage,
            cssClass: 'custom-modal',
        });
        await modal.present();
    }
    fireSearchQuery() {
        if (this.userService.userId === "" && !this.isOpenSearch) {
          this.openLoginModal();
        } else {
          clearTimeout(this.typingTimer);
          if (
            this.searchText.length > 2 &&
            (this.isOpenSearch || this.userService.getUserId())
          ) {
            this.typingTimer = setTimeout(() => {
              //// console.log('in fireSearchQuery...');
              this.showSearchLoader = true;
              this.showNoProducts = false;
              if (!this.searchsubscribed) {
                this.subscribeSearch();
                this.searchsubscribed = true;
              }
              this.events.publish(
                "search-engine:alogoliaSearchProducts",
                this.searchText,
                0,
                "new_search"
              );
            }, this.doneTypingInterval);
          }
        }
      }
      subscribeSearch() {
        this.events.subscribe(
          "search-engine:productSearchResults",
          async (products) => {
            for (let product of products) {
              product = await this.prepareProductData(product);
            }
            this.displaySearchResult = true;
            this.algoliaProducts = products;
            this.showSearchLoader = false;
            this.showNoProducts = false;
          }
        );
        this.events.subscribe("search-engine:noSearchProductsAvailable", () => {
          this.showSearchLoader = false;
          this.showNoProducts = true;
        });
        this.events.subscribe("search-engine:noMoreSearchProducts", () => {
          this.noMoreProducts = true;
          this.showSearchLoader = false;
        });
      }
      async prepareProductData(product: any) {
        const wishlistProducts = await this.storage.get("wishlistProducts");
        const subRole = await this.storage.get("userSubRole");
        const userId = await this.storage.get("uid");
        const data = {
          wishlistProducts,
          subRole,
          userId,
          product,
          cartProducts: this.cartProducts,
        };
        const updatedProduct = await this.sharedService.prepareProductData(data);
        return updatedProduct;
      }
      goToSearchResults() {
        if (this.searchText) {
          this.navCtrl.navigateRoot([
            `search-results/${encodeURL(this.searchText)}`,
          ]);
        }
      }
      onClickProduct(pdt: any) {
        const name = encodeURL(pdt.prodName);
        if (pdt.ptype === "child") {
          this.router.navigate([
            `product-details/${name}/${pdt.parentId}/option/${pdt.objectID}`,
          ]);
        } else {
          this.router.navigate([`product-details/${name}/${pdt.objectID}`]);
        }

        this.removeSubscriptions();
        this.searchsubscribed = false;
        this.searchText = "";
      }
      checkPdtStock(pdt) {
        let isOutOfStock = false;
        if (!pdt.isPriceList) {
          if (pdt.productQty === "0" && pdt.stopWhenNoQty) {
            isOutOfStock = true;
          }
        } else {
          if (pdt.stopWhenNoQty) {
            for (let pl of pdt.priceList) {
              if (pl.totalQuantity !== "0") {
                isOutOfStock = false;
                break;
              } else {
                isOutOfStock = true;
              }
            }
          }
        }
        return isOutOfStock;
      }
      showVendorInfo(vendorName) {
        return this.vendorService.vendorSettings.showVendorInfo && vendorName;
      }
      onClickVendor(product) {
        this.router.navigate([
          `vendor-info/${encodeURL(product.vendorName)}/${product.vendorId}`,
        ]);
      }
      async loadMoreProducts() {
        this.page = this.page + 1;
        this.events.publish(
          "search-engine:alogoliaSearchProducts",
          this.searchText,
          this.page,
          "existing_search"
        );
      }

}
